export default "__VITE_ASSET__6d2f0f76__"